export const CALCULATE_MY_QUOTE = 'Calculate my Quote';
export const DEFAULT_COVERAGE_AMOUNT = 300000;
export const DEFAULT_TERM = 20;
export const GET_LIFE_QUOTE = 'Get Life Quote';
export const LIFE_QUOTE = 'Life Quote';
export const QUOTE_CTA_CLICK = 'Quote CTA Click';
export const SELECT_LIFE_QUOTE = 'Select Life Quote';
export const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];
